import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'

const defaultParams = {
  from: moment().format('YYYY-MM-DD'),
  to: moment().add(30, 'days').format('YYYY-MM-DD'),
}
const module = 'futurview'
let doc = {
  list: {
    name: 'Libérations futures',
    hasMap: true,
    headers: [
      { label: 'Code', value: 'code', truncate: true },
      { label: 'Type', value: 'board_type', truncate: true },
      { label: 'Adresse', value: 'adress', truncate: true },
      { label: 'District', value: 'district' },
      { label: 'Dimensions', value: 'dimensions', card: false },
      { label: 'Surface (m2)', value: 'surface', card: false },
      { label: 'Ville', value: 'city' },
      { label: 'Region', value: 'region' },
      { label: 'A partir du', value: 'dateEnd', orig: 'date_end' },
    ],
    actions: [
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    search: [
      { label: 'Début', type: 'date', name: 'from', classes: 'md6' },
      { label: 'Fin', type: 'date', name: 'to', classes: 'md6' },
    ],
  },

  form: {},

  postprocess: item => {
    let dateEnd = moment(item.date_end).format('DD/MM/YYYY')
    let position = {lng: parseFloat(item.lon), lat: parseFloat(item.lat)}
    return {
      ...item,
      dateEnd,
      position,
    }
  },

  params: {
    fetchAll: defaultParams,
    fetchOne: {},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  state: {
    search: {
      data: defaultParams,
    },
  },
}

export default merge(base, custom)
